import { useEffect } from 'react'
import { useUser } from '@/entities/user'
import { useUserStore } from '@/entities/user/model/user-store'

/**
 * Компонент для синхронизации состояния между API и Zustand stores
 * 
 * Корзина и избранное теперь полностью серверные - синхронизация не нужна.
 * Этот компонент синхронизирует только пользователя.
 */
export function StateSync() {
  // Синхронизация пользователя
  const { data, isLoading, error } = useUser()
  const { setUser, setLoading, setError } = useUserStore()
  
  // Используем useEffect для синхронизации пользователя
  useEffect(() => {
    if (data?.data) {
      setUser(data.data)
    }
  }, [data, setUser])
  
  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading, setLoading])
  
  useEffect(() => {
    setError(error?.message || null)
  }, [error, setError])
  
  return null
}
